// removed by extract-text-webpack-plugin
module.exports = {"block":"DmcaHeader_block_1r2Rb","content":"DmcaHeader_content_1iChY","logo":"DmcaHeader_logo_aAB3N"};